/**
 * Zentrale Title-/Description-Vorgaben je Route (DE).
 * Ziel: eindeutige Titles (<= 60 Zeichen, immer mit Marke) und
 * Descriptions zwischen 120 und 158 Zeichen – ohne Inhalte der Seite zu ändern.
 */
export interface PageSeoEntry {
  title: string;
  description: string;
}

export const PAGE_SEO: Record<string, PageSeoEntry> = {
  "/": {
    title: "Ferienwohnung Kappl & Ischgl | Lerch Suites",
    description:
      "Lerch Suites in Kappl im Paznaun: vier stilvolle Boutique-Apartments mit Wellness, nur sieben Minuten von Ischgl. Jetzt Suite direkt online buchen.",
  },
  "/suites": {
    title: "Suiten & Apartments in Kappl | Lerch Suites",
    description:
      "Vier individuelle Suiten in Kappl im Paznaun: 60 bis 95 m², eigene Küche, Balkon und Bergblick. Ausstattung, Belegung und Preise im Überblick.",
  },
  "/suites/deluxe-suite": {
    title: "Deluxe-Suite in Kappl | Lerch Suites",
    description:
      "Die Deluxe-Suite der Lerch Suites in Kappl: großzügiger Wohnraum, drei Schlafzimmer, voll ausgestattete Küche und Bergblick für bis zu sechs Gäste.",
  },
  "/suites/swiss-suite": {
    title: "Swiss-Suite in Kappl | Lerch Suites",
    description:
      "Die Swiss-Suite der Lerch Suites in Kappl verbindet alpines Design mit modernem Komfort: eigene Küche, Wohnbereich, Balkon und Blick ins Paznaun.",
  },
  "/suites/garten-suite": {
    title: "Garten-Suite in Kappl | Lerch Suites",
    description:
      "Die Garten-Suite der Lerch Suites in Kappl liegt ebenerdig mit eigener Terrasse: ruhige Lage, voll ausgestattete Küche und direkter Gartenzugang.",
  },
  "/suites/austria-suite": {
    title: "Austria-Suite in Kappl | Lerch Suites",
    description:
      "Die Austria-Suite der Lerch Suites in Kappl bietet warmes Tiroler Holz, moderne Ausstattung, eigene Küche und Balkon mit Blick auf die Berge.",
  },
  "/lerch-plus": {
    title: "Lerch Plus: Frühstück & Service | Lerch Suites",
    description:
      "Lerch Plus ergänzt Ihren Aufenthalt in Kappl: Frühstücksservice, Wellness und persönliche Extras – flexibel zu jeder Suite dazu buchbar.",
  },
  "/wellness": {
    title: "Wellness & Sauna in Kappl | Lerch Suites",
    description:
      "Wellness in den Lerch Suites in Kappl: Sauna, Ruhebereich und Erholung nach dem Ski- oder Wandertag. Alle Infos zu Bereich und Nutzung im Überblick.",
  },
  "/erlebnisse": {
    title: "Erlebnisse im Paznaun | Lerch Suites",
    description:
      "Sommer wie Winter: Wandern, Biken, Skifahren in Kappl und Ischgl sowie Events im Paznaun – Ihre Erlebnisse rund um die Lerch Suites in Tirol.",
  },
  "/erlebnisse/sommer": {
    title: "Sommerurlaub in Kappl & Paznaun | Lerch Suites",
    description:
      "Sommer im Paznaun: Wandern, Bergbahnen, Mountainbiken und Ausflüge rund um Kappl und Ischgl – Tipps für Ihren Aufenthalt in den Lerch Suites.",
  },
  "/erlebnisse/winter": {
    title: "Skiurlaub in Kappl & Ischgl | Lerch Suites",
    description:
      "Winter im Paznaun: Skigebiet Kappl, Ischgl und Galtür, Skipässe, Skiraum und Anreise – alles für Ihren Skiurlaub in den Lerch Suites in Tirol.",
  },
  "/erlebnisse/top-events": {
    title: "Top Events im Paznaun | Lerch Suites",
    description:
      "Konzerte, Bergfeste und Sportevents in Kappl, Ischgl und im Paznaun: die wichtigsten Termine für Ihren Aufenthalt in den Lerch Suites in Tirol.",
  },
  "/bewertungen": {
    title: "Gästebewertungen | Lerch Suites",
    description:
      "Was Gäste über die Lerch Suites in Kappl sagen: Bewertungen zu Suiten, Wellness, Sauberkeit, Lage und Gastgebern – gesammelt aus Google und Portalen.",
  },
  "/buchen": {
    title: "Suite online buchen | Lerch Suites",
    description:
      "Verfügbarkeit prüfen und Ihre Suite in Kappl im Paznaun direkt online buchen – zum Bestpreis, ohne Vermittlungsgebühr, mit schneller Bestätigung.",
  },
  "/anfrage": {
    title: "Unverbindliche Anfrage | Lerch Suites",
    description:
      "Stellen Sie Ihre unverbindliche Anfrage an die Lerch Suites in Kappl: Wunschtermin, Personenzahl und Sonderwünsche – wir melden uns kurzfristig.",
  },
  "/lage-anreise": {
    title: "Lage & Anreise nach Kappl | Lerch Suites",
    description:
      "So finden Sie zu den Lerch Suites in Kappl: Anreise mit Auto, Bahn oder Flug, Parkplätze am Haus und Entfernungen nach Ischgl und ins Paznaun.",
  },
  "/impressum": {
    title: "Impressum | Lerch Suites",
    description:
      "Impressum der Lerch Suites in Kappl im Paznaun: Angaben zum Betreiber, Kontaktdaten, Rechtsform und Hinweise zur Online-Streitbeilegung in Tirol.",
  },
  "/datenschutz": {
    title: "Datenschutz | Lerch Suites",
    description:
      "Datenschutzerklärung der Lerch Suites: Informationen zu Verarbeitung, Speicherung und Ihren Rechten bei Buchungen, Anfragen und Website-Nutzung.",
  },
  "/barrierefreiheit": {
    title: "Barrierefreiheit | Lerch Suites",
    description:
      "Barrierefreiheitserklärung der Lerch Suites in Kappl: Maßnahmen für eine zugängliche Website, bekannte Einschränkungen und Ihr Weg zum Feedback.",
  },
  "/sitemap": {
    title: "Sitemap | Lerch Suites",
    description:
      "Übersicht aller Seiten der Lerch Suites in Kappl: Suiten, Wellness, Lerch Plus, Erlebnisse, Buchung, Anfrage sowie Lage, Anreise und Rechtliches.",
  },
};

/** Liefert die redaktionellen SEO-Vorgaben für einen Pfad (ohne Sprach-Präfix). */
export const getPageSeo = (pathname: string): PageSeoEntry | undefined => {
  const clean =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return PAGE_SEO[clean || "/"];
};

/** Kürzt eine Description auf maximal 158 Zeichen an der Wortgrenze. */
export const clampDescription = (text: string, max = 158): string => {
  const normalized = text.replace(/\s+/g, " ").trim();
  if (normalized.length <= max) return normalized;
  const cut = normalized.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > 80 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:–-]+$/, "")}…`;
};
